import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Subject} from 'rxjs/Subject';
import {BsModalRef} from 'ngx-bootstrap';
import {CorsiService} from '../../formativa/corsi.service';

@Component({
  selector: 'app-cerca-tesserato',
  templateUrl: './cerca-tesserato.component.html'
})

export class CercaTesseratoComponent implements OnInit {

  formatori: any[] = []
  courseId: number;
  projectId: number;
  buttonPrefix;
  isStudent: boolean;
  enableCardCode: boolean;
  regularForm: FormGroup;
  selectedFormatore: any;
  selectedFormatoreIndex: number;
  public onClose: Subject<any>;
  forceDiscipline:boolean;
  constructor(
    private fb: FormBuilder,
    public bsModalRef: BsModalRef,
    private corsiService: CorsiService
  ) {}

  ngOnInit(): void {
    this.onClose = new Subject();
    this.inizializeForm();
  }

  private inizializeForm() {
    this.regularForm = this.fb.group({
      code: [null],
      cardCode: [null],
      lastname: [null],
      cf: [null],
    });

    this.regularForm.get('code').valueChanges.subscribe((value) => {
      if (value) {
        this.regularForm.get('lastname').setValue(null);
        this.regularForm.get('cardCode').setValue(null);
        this.regularForm.get('cf').setValue(null);
      }
    });
    this.regularForm.get('cardCode').valueChanges.subscribe((value) => {
      if (value) {
        this.regularForm.get('lastname').setValue(null);
        this.regularForm.get('cf').setValue(null);
        this.regularForm.get('code').setValue(null);
      }
    });
    this.regularForm.get('lastname').valueChanges.subscribe((value) => {
      if (value) {
        this.regularForm.get('code').setValue(null);
        this.regularForm.get('cardCode').setValue(null);
        this.regularForm.get('cf').setValue(null);
      }
    });
    this.regularForm.get('cf').valueChanges.subscribe((value) => {
      if (value) {
        this.regularForm.get('lastname').setValue(null);
        this.regularForm.get('cardCode').setValue(null);
        this.regularForm.get('code').setValue(null);
      }
    });
  }

  cercaFormatore() {
    if (this.courseId) {
      if (!this.isStudent) {
        if (this.forceDiscipline){
          this.corsiService.searchDisciplineSub(this.regularForm.value, this.courseId,true).subscribe((res) => {
            this.formatori = res;
            this.selectedFormatore = null;
          })

        }else {
          this.corsiService.searchTrainers(this.regularForm.value, this.courseId).subscribe((res) => {
            this.formatori = res;
            this.selectedFormatore = null;
          })
        }
      } else {
        if (this.forceDiscipline){

          this.corsiService.searchDisciplineSub(this.regularForm.value, this.courseId,false).subscribe((res) => {
          this.formatori = res;
          this.selectedFormatore = null;
        })
        } else {
          this.corsiService.searchStudents(this.regularForm.value, this.courseId).subscribe((res) => {
            this.formatori = res;
            this.selectedFormatore = null;
          })
        }
      }
    } else {
      if (this.projectId) {
        this.corsiService.projectsearchDisciplineSub(this.regularForm.value, this.projectId).subscribe((res) => {
          this.formatori = res;
          this.selectedFormatore = null;
        })
      }else{
        this.corsiService.searchSubscriber(this.regularForm.value).subscribe((res) => {
          this.formatori = res;
          this.selectedFormatore = null;
        })
      }
    }
  }

  selectFormatore(formatore: any, index: number) {
    this.selectedFormatore = formatore;
    this.selectedFormatoreIndex = index;
  }

  aggiungiFormatore() {
    this.onClose.next(this.selectedFormatore);
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/servizi/tesseramento/cerca-tesserato/cerca-tesserato.component.ts